import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export enum LinesOfBusiness {
  Commercial = 1,
  MedicareAdvantage = 2,
  MedicareFeeForService = 3,
  VeteransAffairs = 4,
  ManagedMedicaid = 5,
  NotSpecified = 7,
  FFSDuals = 8,
  MedicaidFeeForService = 9
}

export interface ILineOfBusiness extends IModelBase {
  Value: string
  IsFFS: boolean
}

@Injectable()
export class LineOfBusinessODataService extends ODataService<ILineOfBusiness> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'LinesOfBusiness'
  }
}
